import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import button from './button.js'
import wrapper from './wrapper.js'

export default contract({
  button: array([
    button
  ]),
  wrapper: array([
    wrapper
  ])
})